class Address {
  constructor(params) {
    this.streetName = params.street;
    this.streetNumber = params.houseNumber;
    this.streetNumberAddition = params.houseNumberAddition ? params.houseNumberAddition : '';
    this.postalCode = params.zipCode;
    this.city = params.city;
    this.countryName = params.country;
    return this;
  }
}
export { Address as default };
